// Flujo de estados de un ticket. Las transiciones válidas las decide el back (TicketWorkflowService) y llegan
// en `nextCodes` de cada estado del catálogo; aquí solo se localiza el estado actual y se presentan las acciones.

// Acción del botón principal de la ficha según el estado actual: texto, estado destino y aviso al completarla
const PRIMARY_ACTIONS = {
  sent: { label: 'ABRIR', target: 'open' },
  open: { label: 'INICIAR', target: 'working' },
  working: { label: 'FINALIZAR', target: 'closed' },
  on_hold: { label: 'REANUDAR', target: 'working' },
  closed: { label: 'REABRIR', target: 'reopened' },
  reopened: { label: 'INICIAR', target: 'working' },
};

const SUCCESS_MESSAGES = {
  open: ticket => `Ticket ${ticket} abierto`,
  working: ticket => `Trabajando en el Ticket ${ticket}`,
  on_hold: ticket => `Ticket ${ticket} en espera`,
  closed: ticket => `Ticket ${ticket} cerrado`,
  reopened: ticket => `Ticket ${ticket} reabierto`,
};

// Estado actual: el de la última fila del histórico (por fecha de inicio; a igualdad, la que viene después)
export function currentStatusOf(histories = []) {
  let current = null;
  for (const history of histories) {
    if (!current || new Date(history.dateStart) >= new Date(current.dateStart)) {
      current = history;
    }
  }
  return current ? current.status : null;
}

export function statusByCode(states, code) {
  return states.find(state => state.code === code) ?? null;
}

// Estados que se ofrecen en el selector: el actual y aquellos a los que se puede pasar desde él
export function selectableStatuses(states, current) {
  if (!current) {
    return states;
  }
  const next = current.nextCodes ?? [];
  return states.filter(state => state['@id'] === current['@id'] || next.includes(state.code));
}

// Botón principal (ABRIR, INICIAR, FINALIZAR, REANUDAR, REABRIR); null si el flujo no permite avanzar desde ahí
export function primaryAction(current) {
  const action = current ? PRIMARY_ACTIONS[current.code] : null;
  return action && (current.nextCodes ?? []).includes(action.target) ? action : null;
}

export function successMessage(code, ticketReference) {
  return SUCCESS_MESSAGES[code]?.(ticketReference) ?? 'Estado cambiado';
}
